import { useAppDispatch, useCheckPermission } from '@vision/ui/hooks';
import { PlannerTaskRelation } from '@vision/ui/interfaces';
import { setTaskRelationToAdd } from '@vision/ui/store';

export function usePlannerTaskRelations() {
  const dispatch = useAppDispatch();
  const isTaskRelationCreationPermitted = useCheckPermission('planner.taskRelation');

  return {
    isTaskRelationCreationPermitted,
    createRelation: (relation: PlannerTaskRelation) => {
      dispatch(setTaskRelationToAdd(relation));
    },
  };
}
